define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/core/ExtendedPath",
	"csi/heading/TextController",
	"csi/xml",
	"./_base"
], function(declare, csi, _, ExtendedPath, TextController, xml, MappingBase) {

	return declare(TextController, {
		bHold: true,

		toWriter: function() {
			// summary: write operations for new attribute value
			var ctx = this.getContext();
			var mappingNode = ctx.getNode();
			var nodeConfigurableAttribute = ctx.getNodeContext();
			var w = this.m_writer;

			var key = MappingBase.getMappingKey(nodeConfigurableAttribute);

			var index = MappingBase.findMappingKeyInSettings(mappingNode, key);

			var newValue = this.newValue;

			var cn = w.changeNode(mappingNode.$URL);
			if (newValue) {
				var bInsert = (index < 0);
				if (bInsert) {
					cn.changeAttributeKeys("ProductAttributeMappingKeys", xml.ATTR_STRINGLIST, csi.objectNew(index, key), bInsert);
				}
				cn.changeAttributeKeys("ProductAttributeMappingExpressions", xml.ATTR_STRINGLIST, csi.objectNew(index, newValue), bInsert);
			} else if (index >= 0) {
				cn.removeAttributeKeys("ProductAttributeMappingKeys", xml.ATTR_STRINGLIST, [index])
					.removeAttributeKeys("ProductAttributeMappingExpressions", xml.ATTR_STRINGLIST, [index]);
			}

			// no need to return results of change - this will only work if this is the only controller
			// writing changes in view!
			w.noReturnNodes();
		}
	});
});